var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"main",style:({
      'background-image': `url(${_vm.bg})`,
    }),attrs:{"id":"bg"}}),_c('div',{staticClass:"bottom"},[_c('div',{staticClass:"info-bar"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"b-content"},[_vm._v(_vm._s(_vm.desc))]),_c('div',{staticClass:"b-audio"},[_c('audio',{attrs:{"id":"audio","src":_vm.audioSrc,"controls":"","type":"audio/mpeg"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }